/// <amd-module name="NetSuite.LogoListCCT.Utils"/>
define("NetSuite.LogoListCCT.Utils", ["require", "exports", "NetSuite.LogoList.Common.Utils"], function (require, exports, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.fieldNamePrefix = 'custrecord_cct_ns_llcct_';
    function getSetting(settings, fieldName, defaultValue) {
        if (!settings) {
            return null;
        }
        var value = defaultValue ? defaultValue : '';
        var setValue = Utils_1.Utils.trim(settings[this.fieldNamePrefix + fieldName]);
        return setValue || value;
    }
    exports.getSetting = getSetting;
    function getSettings(settings, params, prefix) {
        var settingsObject = {};
        var okPrefix = prefix || '';
        for (var i = 0; i < params.length; i++) {
            var param = params[i];
            var simpleParam = typeof param === 'string';
            var name_1 = simpleParam ? param : param.name;
            var fieldName = okPrefix +
                (simpleParam
                    ? param
                    : param.fieldName
                        ? param.fieldName
                        : param.name);
            var defaultValue = simpleParam || !param.default
                ? ''
                : param.default;
            settingsObject[name_1] = this.getSetting(settings, fieldName, defaultValue);
        }
        return settingsObject;
    }
    exports.getSettings = getSettings;
});
